/******************************************************************************************
 * This file holds the APIs for Penetapan by Pengawas Sekolah for Plt KS
 ******************************************************************************************/

import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { TResponsePredikatKinerja } from 'types/kinerja-ps'
import type { UseQueryOptions } from 'react-query'

export const API_GET_KS_PREDIKAT_KINERJA_TAB_GURU =
  'API_GET_KS_PREDIKAT_KINERJA_TAB_GURU'

export function useApiGetPredikatKinerjaTabGuru(
  opts?: UseQueryOptions<TResponsePredikatKinerja>
) {
  return useKinerjaApi<TResponsePredikatKinerja>(
    apiPaths.guruPredikatKinerjaPltKs,
    {
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: [API_GET_KS_PREDIKAT_KINERJA_TAB_GURU],
    }
  )
}
